import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function useRecaptchaToken() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getRecaptchaToken = useCallback(
    async (action?: string): Promise<string | undefined> => {
      if (!executeRecaptcha) return undefined;
      try {
        return await executeRecaptcha(action);
      } catch {
        return undefined;
      }
    },
    [executeRecaptcha],
  );

  return { getRecaptchaToken };
}

export { useRecaptchaToken };
